import React, { ReactElement } from "react";
import styles from "./circularProgress.module.scss";
interface CircularProgressProps {
    scoreValue: number;
    scoreColor: string;
}
export default function CircularProgress({
    scoreValue,
    scoreColor,
}: CircularProgressProps): ReactElement {
    const rightSideStyle = {
        borderColor: scoreColor,
    };
    const pieStyle = {};
    if (scoreValue * 10 <= 50) {
        rightSideStyle["display"] = "none";
    } else {
        rightSideStyle["transform"] = "rotate(180deg)";
        pieStyle["clip"] = "rect(auto, auto, auto, auto)";
    }
    return (
        <div className={`${styles["set-size"]} ${styles["charts-container"]}`}>
            <div className={`${styles["pie-wrapper"]}`}>
                <span className={`${styles["label"]}`}>{scoreValue}</span>
                <div className={`${styles["pie"]}`} style={pieStyle}>
                    <div
                        className={`${styles["left-side"]} ${styles["half-circle"]}`}
                        style={{
                            borderColor: scoreColor,
                            transform: `rotate(${scoreValue * 10 * 3.6}deg)`,
                        }}
                    ></div>
                    <div
                        className={`${styles["right-side"]} ${styles["half-circle"]}`}
                        style={rightSideStyle}
                    ></div>
                </div>
            </div>
        </div>
    );
}
